import { render, staticRenderFns } from "./auditView.vue?vue&type=template&id=3538c938&scoped=true&"
import script from "./auditView.vue?vue&type=script&lang=js&"
export * from "./auditView.vue?vue&type=script&lang=js&"
import style0 from "./auditView.vue?vue&type=style&index=0&id=3538c938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538c938",
  null
  
)

component.options.__file = "auditView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VCardTitle,
  VDataTable,
  VFlex,
  VIcon,
})
